<template>
    <div class="DM_transactionHide">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-date-picker
                            v-model="rangeDate"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="提出开始时间"
                            end-placeholder="提出结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="DateChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addHideRule">添加数据优化规则</el-button>
            </div>
            <el-table
                    :data="feedbackList"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
                    max-height="700px">
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 主机构 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent"
                        label="主机构"
                        min-width="160">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleAgentNet(scope.row)"
                                type="text"
                                size="small"
                        >{{scope.row.agent}}</el-button>
                    </template>
                </el-table-column>
                <!-- 交易类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="pay_type"
                        label="交易类型"
                        min-width="80"
                ></el-table-column>
                <!-- 优化终端类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="brand_id"
                        label="优化终端类型"
                        min-width="100">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleNet(scope.row)"
                                type="text"
                                size="small"
                        >{{scope.row.brand_id}}</el-button>
                    </template>
                </el-table-column>
                <!-- 非优化终端 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="not_terminal_id"
                        label="非优化终端"
                        min-width="80">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleTerminalNet(scope.row)"
                                type="text"
                                size="small"
                                v-if="scope.row.not_terminal_id != 0"
                        >{{scope.row.not_terminal_id}}</el-button>
                        <div
                                type="text"
                                size="small"
                                v-if="scope.row.not_terminal_id == 0"
                        >{{scope.row.not_terminal_id}}</div>
                    </template>
                </el-table-column>
                <!-- 非优化用户 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="not_user_id"
                        label="非优化用户"
                        min-width="80">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleUserNet(scope.row)"
                                type="text"
                                size="small"
                                v-if="scope.row.not_user_id != 0"
                        >{{scope.row.not_user_id}}</el-button>
                        <div
                                type="text"
                                size="small"
                                v-if="scope.row.not_user_id == 0"
                        >{{scope.row.not_user_id}}</div>
                    </template>
                </el-table-column>
                <!-- 延迟笔数 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="delay_sum"
                        label="终端延迟笔数"
                        min-width="120"
                ></el-table-column>
                <!-- 延迟天数 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="delay_days"
                        label="终端延迟天数"
                        min-width="120"
                ></el-table-column>
                <!-- 交易笔数 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="hide"
                        label="交易笔数-优化笔数"
                        min-width="140"
                ></el-table-column>
                <!-- 最低金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="money"
                        label="最低金额-最高金额"
                        min-width="140"
                ></el-table-column>
                <!-- 开始时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="time"
                        label="开始时间-结束时间"
                        min-width="140"
                ></el-table-column>
                <!-- 结束时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="is_deleted"
                        label="状态"
                        min-width="80"
                ></el-table-column>
                <!-- 创建时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="create_time"
                        label="创建时间"
                        min-width="160"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="140">
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row.id)" type="text" size="small">查看已优化数据</el-button>
                        <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑规则</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10,20,50,100]"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <transaction-detail v-if="detail.isShow" :detail="detail" @infoClose="infoClose"></transaction-detail>
        <transaction-edit v-if="detail.edit" :detail="detail" @infoClose="infoClose"></transaction-edit>
    </div>
</template>

<script>
import transactionDetail from './DM_transactionHideDetail';
import transactionEdit from './DM_transactionHideEdit';
export default {
    name: "DM_transactionHide",
    data() {
        return {
            transactionHideAdd: false, //弹窗
            feedbackList: [], //table
            rangeDate: [],
            searchForm: {
                page: 1,
                limit: 10,
                start_create_time: '', //提出开始时间
                end_create_time: '' //提出结束时间
            },
            detail: {
                isShow: false,
                edit:false,
                type: null, //1.优化终端类型 2.非数据优化终端 3. 非数据优化用户
                info: null
            },
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading:false
        }
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    components: {
        transactionDetail,
        transactionEdit
    },
    methods: {
        addHideRule() { //添加分类
            this.$router.push({ path: '/transactionHideAdd' })
        },
        onSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData(searchForm);
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("transaction/transaction_hide_list", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.feedbackList = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        DateChange(DateArr) {
            this.searchForm.start_create_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_create_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
        handleNet(data){
            this.detail.isShow = true;
            this.detail.type = 1;
            this.detail.info = {id:data.id};
        },
        handleTerminalNet(data){
            this.detail.isShow = true;
            this.detail.type = 3;
            this.detail.info = {id:data.id};
        },
        handleUserNet(data){
            this.detail.isShow = true;
            this.detail.type = 2;
            this.detail.info = {id:data.id};
        },
        handleAgentNet(data){
            this.detail.isShow = true;
            this.detail.type = 4;
            this.detail.info = {id:data.id};
        },
        handleInfo(val){
            this.$router.push({ path: '/transactionHideInfo', query: {id:val}});
        },
        infoClose() { //关闭详情
            this.detail.isShow = false;
            this.detail.edit = false;
            this.getData(this.searchForm);
        },
        handleEdit(data){
            this.detail.edit = true;
            this.detail.type = 5;
            this.detail.info = data;
        },
    }
};
</script>
